import { Icon } from "../../../ui";

export const TRANSACTIONS_TABLE_COLUMNS = [
  { accessorKey: "$", header: "ردیف" },
  {
    id: "expander",
    size: 10,
    cell: ({ row }: { row: any }) => {
      return row.getCanExpand() ? (
        <button
          className="button--striped"
          {...{
            onClick: row.getToggleExpandedHandler(),
          }}
        >
          {row.getIsExpanded() ? (
            <Icon type="arrow-left" />
          ) : (
            <Icon type="arrow-bottom" />
          )}
        </button>
      ) : null;
    },
  },
  {
    accessorKey: "reference_number",
    header: "شماره مرجع",
  },
  { accessorKey: "tracking_number", header: "کد رهگیری" },
  { accessorKey: "buy_Id", header: "کد خرید" },
  { accessorKey: "amount", header: "مبلغ(ریال)" },
  { accessorKey: "time", header: "ساعت" },
  { accessorKey: "date", header: "تاریخ" },
  { accessorKey: "status", header: "وضعیت تراکنش" },
  { accessorKey: "card_number", header: "شماره کارت" },
];
